import useHasAccessToGoogleRCS from '@rsos/hooks/useHasAccessToGoogleRCS';
import { ChatComponentType, useChatComponents } from '../../useChatComponents';
import ConversationsChatCard from './ConversationsChatCard';
import RcsChatCard from './RcsChatCard';
import TF911ChatCard from './TF911ChatCard';

interface ChatCardDisplayProps {
  hasConversation: boolean;
  hasAccessToTF911: boolean;
  shouldRenderRcsChatCard: boolean;
}

/**
 * Handles all conditionals that would determine which chat card to display
 */
const ChatCardDisplay = ({
  hasConversation,
  hasAccessToTF911,
  shouldRenderRcsChatCard,
}: ChatCardDisplayProps) => {
  const { primaryChatKey } = useChatComponents();
  const hasRCSAccess = useHasAccessToGoogleRCS();
  if (primaryChatKey === ChatComponentType.conversations && hasConversation) {
    return <ConversationsChatCard />;
  }

  if (
    primaryChatKey === ChatComponentType.rcs &&
    hasRCSAccess &&
    shouldRenderRcsChatCard
  ) {
    return <RcsChatCard />;
  }

  if (hasAccessToTF911) {
    return <TF911ChatCard />;
  }

  return null;
};

export default ChatCardDisplay;
